var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCloseWide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.072 4.23c-.475 0-.95.18-1.306.536a1.863 1.863 0 000 2.613L9.389 12l-4.623 4.621a1.863 1.863 0 000 2.613c.356.357.835.541 1.306.541.471 0 .95-.184 1.307-.54L12 14.612l4.621 4.621c.357.357.836.541 1.307.541s.95-.184 1.306-.54c.714-.714.714-1.9 0-2.614L14.614 12l4.62-4.621c.714-.713.714-1.9 0-2.613a1.864 1.864 0 00-2.613 0L12 9.386l-4.621-4.62a1.843 1.843 0 00-1.307-.536zM13.198 12l5.329-5.329a.847.847 0 10-1.198-1.198L12 10.802 6.671 5.473a.847.847 0 10-1.198 1.198l5.329 5.33-5.329 5.328a.847.847 0 101.198 1.198l5.33-5.329 5.328 5.329a.845.845 0 001.198 0 .847.847 0 000-1.198z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloseWide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-close-wide.94c9241f8907d8ba085ec50cce87a28b.svg";